<div class="mention-timeline-container">
  <achoo-stacked-column-chart
    *ngIf="!isNoData"
    [chartData]="chartData"
    [height]="265"
    [chartTitle]=""
  >
  </achoo-stacked-column-chart>
</div>
<div
  *ngIf="isNoData"
  class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/mention-timeline-report/mention-timeline-report.component.html